import React from 'react';

const ClockOut = () => {
  return (
    <div>
      <h1>Clock Out</h1>
      <p>This page is only accessible from Telegram Web App on a phone.</p>
    </div>
  );
};

export default ClockOut;
